import axios from "axios";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import appointments from "../redux/reducers/appointmentReducer";
import doctors from "../redux/reducers/doctorReducer";
import services from "../redux/reducers/serviceReducer";
import specialities from "../redux/reducers/specialityReducer";
import doctorTabsReducer from "../redux/reducers/doctorTabsReducer";

import user from "../redux/reducers/userReducer";
import { loadState } from "./localStorage";

export const history = createBrowserHistory();

history.listen((location, action) => {
  window.scrollTo(50, 0);
});

const rootReducer = combineReducers({
  router: connectRouter(history),
  user,
  doctors,
  specialities,
  services,
  appointments,
  doctorTabsReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [thunkMiddleware, routerMiddleware(history)];
const enhancers = composeEnhancers(applyMiddleware(...middleware));

const persistedState = loadState();
const store = createStore(rootReducer, persistedState, enhancers);

const waitForSession = () => {
  return new Promise((resolve) => {
    const check = () => {
      const state = store.getState();
      return state.user?.SessionId || localStorage.getItem("Session_Id");
    };

    const session = check();
    if (session) return resolve(session);

    const unsubscribe = store.subscribe(() => {
      const newSession = check();
      if (newSession) {
        unsubscribe();
        resolve(newSession);
      }
    });

    setTimeout(() => {
      unsubscribe();
      resolve(null);
    }, 15000);
  });
};

axios.interceptors.request.use(async (config) => {
  if (
    config.url.includes("/login") ||
    config.url.includes("/auth") ||
    config.url.includes("/Registration")
  ) {
    return config;
  }

  try {
    const sessionId = await waitForSession();
    if (sessionId) {
      config.headers["Session_Id"] = sessionId;
    }
  } catch (e) {
    console.error("Interceptor error:", e);
  }
  return config;
});

export default store;
